import { createContext } from 'react'

const LikedProductsContext = createContext()

export default LikedProductsContext
